import { createAction, createPayloadAction } from '../../../core/helpers'

import { FETCH_DIET, SET_DIET_PAGE_TO_DIRTY } from '../action-types'

export const cleanupFetchDiet = createAction(FETCH_DIET.CLEANUP)
export const setDietPageIsDirty = createPayloadAction(SET_DIET_PAGE_TO_DIRTY)
